import { render, staticRenderFns } from "./TableEdit.vue?vue&type=template&id=2b83a736&"
import script from "./TableEdit.vue?vue&type=script&lang=js&"
export * from "./TableEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b83a736')) {
      api.createRecord('2b83a736', component.options)
    } else {
      api.reload('2b83a736', component.options)
    }
    module.hot.accept("./TableEdit.vue?vue&type=template&id=2b83a736&", function () {
      api.rerender('2b83a736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabAvatar/components/TableEdit.vue"
export default component.exports